<!-- 设备详情 -->
<template>
    <div class="content">
        <div class="equipm xrow ai-c jc-sb">
            <div class="equipm-desc flex2">
                <div class="encoder-bg"></div>
                <div class="equ-cc">
                    <h3>土壤多参数自动监测站</h3>
                    <p>
                        <span>型号：{{ modal }}</span>
                        <span>编码：{{ type }}</span>
                        <span>名称：{{ name }}</span>
                    </p>
                </div>
            </div>
            <div class="equipm-status flex3 mgl30 xrow ai-c jc-s pdh20">
                <!-- <div class="equ-net pdh30">
                    <i>
                        <el-image :src="require('../../../assets/status/run.png')"
                            v-if="Encoder.AlarmEvent === 0"></el-image>
                        <el-image :src="require('../../../assets/status/stop.png')" v-else></el-image>
                    </i>
                    <b>{{ status === "有效" ? '运行中' : '离线' }}</b>
                    <span>网络类型：4G</span>
                </div> -->
                <div class="equ-sensor xrow ai-c jc-c pdh30">
                    <div class="xcol ai-c jc-c pdv15 mgh20 minw70">
                        <b class="fs18">自动</b><i class="mgt25"><img src="../../../assets/category/soil-auto.png"></i><span
                            class="mgt20 color-m1f fs14">{{ SensorsAutoLength }}个指数</span>
                    </div>
                    <!-- <div class="xcol ai-c jc-c pdv15 mgh20 minw70">
                        <b class="fs18">移动</b><i class="mgt25"><img src="../../../assets/category/soil-map.png"></i><span class="mgt20 color-m1f fs14">{{SensorsMove.length}}个指标</span>
                    </div> -->
                    <div class="xcol ai-c jc-c pdv15 mgh20 minw70 bd">
                        <b class="fs18">人工</b><i class="mgt25"><img src="../../../assets/category/soil-mau.png"></i><span
                            class="mgt20 color-m1f fs14">{{ SensorsMau.length }}个指数</span>
                    </div>
                </div>
                <div class="equ-alarm xrow ai-c- jc-s pdv20">
                    <div :class="[status ? '' : 'out-line', 'status', 'mgr10', 'pd30', 'xcol', 'ai-c', 'jc-sb', 'w140']">
                        <i><img src="../../../assets/status/ll-7.png"></i><span>{{ status
                            ? "在线" : "离线" }}</span>
                    </div>
                    <!-- <div class="alarm mgr10 pd30 xcol ai-c jc-sb w140">
                        <i>{{ AlarmCount }}</i><span>报警事件</span>
                    </div> -->
                    <div class="location pd30 xcol ai-c jc-sb w140">
                        <i><img src="../../../assets/status/ll-8.png"></i><span>{{ address }}</span><span
                            style="white-space: nowrap;margin-top: 5px;">{{
                                factory
                            }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="monitor mgt20">
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh30 unselect" v-if="autoDataList.length"
                v-for="(item, index) in autoDataList" :key="index">
                <div class="pl-title lh50 xrow ai-c">
                    <img src="../../../assets/category/soil-item-auto.png">
                    <span class="color-m09 fs20 lsp2 fw-bd mgl10">{{ getTitle(item) }}</span>
                </div>
                <div class="pl-content">
                    <div class="border">
                        <div class="xrow ai-c soil-cell-container">
                            <div class="flex1 soil-cell"><img src="../../../assets/icon/default2.png" />采样深度</div>


                            <div class="flex1 soil-cell"><img src="../../../assets/icon/125.png" />温度(℃)</div>
                            <div class="flex1 soil-cell"><img src="../../../assets/icon/126.png" />湿度(%)</div>
                            <div class="flex1 soil-cell"><img src="../../../assets/icon/129.png" />电导率(mS/cm)</div>
                            <div class="flex1 soil-cell"><img src="../../../assets/icon/128.png" />土壤墒情</div>
                        </div>
                        <div class="xrow">
                            <div class="flex1 soil-cell">20CM</div>


                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'temperature20CM')">{{
                                item.temperature20CM ?? "" }}</div>
                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'moisture20CM')">{{
                                item.moisture20CM ?? "" }}</div>
                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'conductivity20CM')">{{
                                item.conductivity20CM ?? "" }}</div>
                            <!-- <div class="flex1 soil-cell">{{ item ? "适宜" : "" }}</div> -->
                            <div class="flex1 soil-cell">{{ getItem(20, item) }}</div>
                        </div>
                        <div class="xrow">
                            <div class="flex1 soil-cell">40CM</div>


                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'temperature40CM')">{{
                                item.temperature40CM ?? "" }}</div>
                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'moisture40CM')">{{
                                item.moisture40CM ?? "" }}</div>
                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'conductivity40CM')">{{
                                item.conductivity40CM ?? "" }}</div>
                            <!-- <div class="flex1 soil-cell">{{ item ? "适宜" : "" }}</div> -->
                            <div class="flex1 soil-cell">{{ getItem(40, item) }}</div>
                        </div>
                        <div class="xrow">
                            <div class="flex1 soil-cell">60CM</div>


                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'temperature60CM')">{{
                                item.temperature60CM ?? "" }}</div>
                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'moisture60CM')">{{
                                item.moisture60CM ?? "" }}</div>
                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'conductivity60CM')">{{
                                item.conductivity60CM ?? "" }}</div>
                            <!-- <div class="flex1 soil-cell">{{ item ? "适宜" : "" }}</div> -->
                            <div class="flex1 soil-cell">{{ getItem(60, item) }}</div>
                        </div>
                        <div class="xrow">
                            <div class="flex1 soil-cell">80CM</div>


                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'temperature80CM')">{{
                                item.temperature80CM ?? "" }}</div>
                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'moisture80CM')">{{
                                item.moisture80CM ?? "" }}</div>
                            <div class="flex1 soil-cell cur-p" @click="gotoDetail1(item.device.key, 'conductivity80CM')">{{
                                item.conductivity80CM ?? "" }}</div>
                            <!-- <div class="flex1 soil-cell">{{ item ? "适宜" : "" }}</div> -->
                            <div class="flex1 soil-cell">{{ getItem(80, item) }}</div>
                        </div>
                    </div>
                    <el-row>
                        <el-col :span="3" v-for="(it, subIndex) in getSensorsAuto(item)" :key="subIndex">

                            <div class="sensor-item xcol ai-c jc-c" style="cursor: pointer;" @click="gotoDetail(it)">
                                <img :src="getImg(it.Resource)" @error="defImg()">
                                <div class="color-m16 fs24 fw-bd pdv15">{{ it.value }}</div>
                                <div class="color-m5b fs16 pdv5">{{ it.label }}</div>
                                <i class="el-icon-time"></i>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>







            <div class="pl-pannel bg-w bdrd10 pdv20 pdh20 mgt20 unselect">
                <div class="pl-title lh50 xrow ai-c">
                    <img src="../../../assets/category/soil-item-mau.png">
                    <span class="color-m09 fs20 lsp2 fw-bd mgl10">土壤人工检测数据</span>
                </div>
                <div class="pl-content">
                    <el-row>
                        <el-col :span="3" v-for="(item, index) in SensorsMau" :key="index">
                            <div class="sensor-item xcol ai-c jc-c">
                                <img :src="require('../../../assets/icon/default1.png')">
                                <div class="color-m16 fs24 fw-bd pdv15">{{ item.value }}</div>
                                <div class="color-m5b fs16 pdv5">{{ item.label }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="pl-pannel bg-w bdrd10 pdv20 pdh20 mgt20 unselect">
                <div class="pl-title lh50 xrow ai-c">
                    <img src="../../../assets/category/te-2.png">
                    <span class="color-m09 fs20 lsp2 fw-bd mgl10">土壤主要障碍因子研判与耕地质量等级评价</span>
                </div>
                <div class="pl-content pdt20">
                    <documentword :encoderId="EncoderId"></documentword>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { find, forEach } from 'lodash'
import { get } from "@/utils/http";
import { getIcon } from '@/common/pes.utils.js'
import { soilParamList1, soilParamList2, soilParamList3 } from "@/utils/config.js"
import documentword from '@/components/document-word'
import sensorconfig from './config.js'
// import {deviceTypeList} from "@/utils/config.js"
export default {
    components: { documentword },
    data() {
        return {
            EncoderId: '',
            Sensors: [],
            city: "",
            model: "",
            type: "",
            status: "",
            address: "",
            Encoder: {},
            AlarmCount: 0,
            defaultImg: '../../../assets/icon/default1.png',
            SensorsAuto: [],
            SensorsMau: [],
            info: null,
            modal: "",
            deviceName: "",
            SensorsAutoLength: 0,
            factory: "",
            name: "",
            autoDataList: []
        }
    },
    mounted() {

        this.EncoderId = this.$route.params.id;
        this.loadData()
        // this.getLandDetail()
        const item = this.$store.state.currentItem;
        if (item) {
            const obj = JSON.parse(item)
            this.model = obj.model;
            this.type = obj.key;
            this.status = obj.online;
            this.address = obj.location.province + obj.location.city
            this.factory = `${obj.location.district ? obj.location.district : ''}${obj.location.town ? obj.location.town : ''}`;
            this.modal = obj.model;
            this.name = obj.name;
        }
    },
    methods: {
        getItem(param, item) {
            if (!item) return '';
            const temperature = item[`temperature${param}CM`];
            const moisture = item[`moisture${param}CM`];
            const conductivity = item[`conductivity${param}CM`];
            let str = temperature + moisture + conductivity;
            return str ? "适宜" : "";
        },
        loadData() {
            get(`/metrics/soil/latest?key=${this.EncoderId}`).then(res => {

                if (res.data) {
                    this.autoDataList = res.data;
                    let count = 0;
                    forEach(res.data, item => {
                        forEach(soilParamList1, it => {
                            if (item[it.key] || item[it.key] === 0) {
                                count = count + 1;
                            }
                        })

                    });
                    this.SensorsAutoLength = count;

                }
            })
            // axios({
            //     url: `/metrics/soil/latest?key=${this.EncoderId}`,
            //     method: "get",
            //     Headers:{
            //         'x-auth-token':'0b0960ac-e4c9-48bf-b61a-0ba61ceb69b1'
            //     }
            // }).then((res) => {

            // });
        },
        browser() {
            //判断是否支持 获取本地位置
            if (navigator.geolocation) {
                var n = navigator.geolocation.getCurrentPosition(
                    function (res) {
                        console.log(res); // 需要的坐标地址就在res中
                    },
                    function (err) {
                        console.log(err)
                    }
                );
            } else {
                alert('该浏览器不支持定位');
            }
        },
        defImg() {
            let img = event.srcElement
            img.src = this.defaultImg
            img.onerror = null // 防止闪图
        },
        getImg(Resource) {
            return getIcon(Resource)
        },
        gotoDetail(item) {
            // console.log('item==',item)
            const key = item.key;
            const type = item.type;
            this.$router.push({
                path: `/encoder/soil/sensor/${type}/${key}`,
                // query: { id:marker.key },
            });

        },
        gotoDetail1(key, type) {
            this.$router.push({
                path: `/encoder/soil/sensor/${type}/${key}`,
                // query: { id:marker.key },
            });
        },
        getLandDetail() {
            //  this.EncoderId = 2305100008;
            get(`/farmland?key=${this.EncoderId}`).then(res => {
                if (res.data) {
                    const list = [];
                    //  console.log("soilParamList2", soilParamList2)
                    for (var key in res.data) {

                        const o = find(soilParamList2, { key: key });
                        if (o) {
                            //  console.log("ooo",...res.data.device)
                            list.push({ label: o.label, value: `${res.data[key]}${o.unit}`, Resource: o.Resource, ...res.data[key], type: o.key, ...o, ...res.data.device })
                        }
                    };
                    //  console.log("Ccc", list)
                    this.SensorsMau = list
                }
            })
        },
        getTitle(item) {
            if (item.device.model.indexOf("LpWAN") !== -1) {
                return item.device.name
            };
            return "土壤自动监测数据"
        },
        getSensorsAuto(item) {
            var list = [];
            for (var key in item) {
                const o3 = find(soilParamList3, { key: key });

                if (o3) {
                    //  console.log("ooo",...res.data.device)
                    list.push({ label: o3.label, value: `${item[key]}${o3.unit}`, Resource: o3.Resource, ...item[key], type: o3.key, ...o3, ...item.device })
                }

            };
            return list;
        }
    }
}
</script>
<style lang='less' scoped>
.content {
    position: relative;
    left: 165px;
    top: 90px;
    width: calc(100vw - 175px);
    height: calc(100vh - 90px);
    overflow-y: auto;
    overflow-x: hidden;
    padding: 30px;
}

.color-m09 {
    color: #090e15;
}

.color-m16 {
    color: #162437;
}

.color-m5b {
    color: #5b6580;
}

.color-m27 {
    color: #273447;
}

.color-m1f {
    color: #1f2d3f;
}

.equipm {
    position: relative;
    overflow: hidden;

    .equipm-desc {
        background: url(../../../assets/status/m-3.png) no-repeat;
        background-size: 100% 100%;
        height: 200px;
        padding-left: 25px;
        position: relative;
        z-index: 12;

        .encoder-bg {
            position: absolute;
            top: 0;
            right: 0;
            height: 100%;
            width: 60%;
            z-index: -1;

            &::before {
                content: '';
                display: inline-block;
                width: 100%;
                height: 100%;
                // background: url(../../../assets/encoder/soil.png) no-repeat;
                background-position: right top;
                background-size: 70%;
            }
        }

        .equ-cc {
            height: 200px;
            text-align: left;

            h3 {
                font-weight: bold;
                font-size: 28px;
                color: #fff;
                padding-top: 35px;
                letter-spacing: 2px;
            }

            p {
                margin: 0;
                margin-top: 15px;

                span {
                    display: block;
                    font-size: 16px;
                    color: #fff;
                    line-height: 24px;
                }
            }
        }
    }

    .equipm-status {
        background-color: #fff;
        height: 200px;
        border-radius: 10px;

        .equ-net {
            text-align: center;

            b {
                display: block;
                font-size: 18px;
                color: #273447;
                margin: 10px 0;
                margin-top: 15px;
            }

            span {
                display: block;
                color: #8892a0;
                font-size: 14px;
                min-width: 100px;
            }

            i {
                display: block;
                padding-top: 20px;
            }
        }

        .equ-sensor {
            // border-left: solid 1px #f0f0f0;
            margin-top: 21px;
        }

        .equ-alarm {
            height: 200px;
            text-align: center;
            margin: 0;

            .status {
                background: url(../../../assets/status/ll-4.png) no-repeat;
                background-size: 100% 100%;
            }

            .alarm {
                background: url(../../../assets/status/ll-5.png) no-repeat;
                background-size: 100% 100%;
            }

            .location {
                background: url(../../../assets/status/ll-6.png) no-repeat;
                background-size: 100% 100%;
            }

            i {
                display: inline-block;
                width: 48px;
                height: 48px;
                line-height: 48px;
                color: #fff;
                font-size: 42px;
                font-weight: bold;
            }

            span {
                display: block;
                font-weight: bold;
                font-size: 16px;
                color: #fff;
                margin-top: 20px;
            }
        }
    }
}

.sensor-item {
    padding: 10px 10px;
    margin-top: 20px;
    position: relative;

    i {
        position: absolute;
        top: 5px;
        right: 5px;
        color: rgba(176, 185, 210, 0.8);
    }

    &:hover {
        background: rgba(176, 185, 210, 0.1);
    }

    &:after {
        content: '';
        position: absolute;
        height: 80%;
        width: 1px;
        top: 10%;
        right: 0px;
        background: #ecf1f9;
    }
}

.border {
    border: 1px solid #d8d8d8;
    border-bottom-width: 0;
    border-left-width: 0;
}

.soil-cell {
    font-size: 16px;
    padding: 15px;
    border-left: 1px solid #d8d8d8;
    border-bottom: 1px solid #d8d8d8;
}

.soil-cell-container {
    .soil-cell {
        font-weight: bold;

        img {
            width: 2vw;
            margin-right: 10px;
        }
    }


}

.cur-p:hover {
    cursor: pointer;
    background: #d5d5d536;
}

.el-col-3 {
    width: 18.5%;
}

.bd {
    border-left: 1px solid #f0f0f0;
    padding-left: 40px;
}

.out-line {
    background: #cacaca !important;
    border-radius: 12px;
}
</style>
